import {endpoints} from './endpoints'
import request from '../request'

export function getCompanyClients (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyClients,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyClient (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyClient,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getCompanyClientsAprovals (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getCompanyClientsAprovals,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getAccountByEmail (params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getAccountByEmail,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function associateUserToAccount (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.associateUserToAccount,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}